import { Icon, addCollection } from "@iconify/react";

import iconifyBundle from "@/data/iconify-bundle.json";

/**
 * ⭐ 아이콘을 **우리 것으로** 들고 있는다.
 *
 * 예전에는 화면을 열 때마다 `api.iconify.design` 으로 5~6번 나갔다
 * (실측 2026-08-13: /play 5건 943ms · /places 6건 779ms — 받는 건 4KB뿐).
 * 남의 서버라 느리면 아이콘이 늦게 뜨고, 막히면 안 뜬다.
 * 지도 글꼴·아이콘은 2026-08-09 에 우리 쪽으로 옮겼는데 앱 아이콘만 남아 있었다.
 *
 * 이제 쓰는 아이콘 292개를 빌드 때 한 번 받아 `src/data/iconify-bundle.json` 에 묶어 두고,
 * 여기서 **첫 렌더 전에** 등록한다(gzip 31KB).
 *
 * ⚠️ `addCollection` 은 **모듈이 읽히는 순간** 돌아야 한다. 나중에(useEffect 등) 하면
 *    그 전에 그려진 아이콘이 이미 API 를 부르러 나간다.
 * ⚠️ 묶음에 없는 아이콘은 예전처럼 API 로 받는다 — 새 아이콘을 쓰고 다시 묶는 걸 잊어도
 *    화면이 깨지지 않는다. 다시 묶으려면 `node scripts/build-iconify-bundle.mjs`.
 */
let registered = false;
if (!registered) {
  registered = true;
  for (const collection of Object.values(iconifyBundle || {})) {
    try {
      addCollection(collection);
    } catch {
      // 한 묶음이 잘못돼도 나머지는 살린다. 못 담긴 것은 예전처럼 API 로 받는다.
    }
  }
}

// 마스크로 그리는 것들 — 색을 글자색에 맞춰야 해서 SVG 파일을 직접 쓴다.
const LOCAL_ICON_MASKS = {
  "lucide:search": "/icons/play/search.svg",
  "lucide:map-pin": "/icons/main/mappinned.svg",
  "lucide:trending-up": "/icons/main/trending-up.svg",
  "ci:bell": "/icons/mobile-nav/bell.svg",
  "ri:chat-ai-line": "/icons/play/comment.svg",
  "fluent:navigation-24-filled": "/icons/play/menu.svg",
  "clarity:administrator-line": "/icons/main/admin.svg",
};

const Iconify = ({ icon, className, onClick, style, ...others }) => {
  const localIconSrc = LOCAL_ICON_MASKS[icon];

  if (localIconSrc) {
    return (
      <span
        className={`block w-5 h-5 dark:text-dark_primary_label text-light_primary_label cursor-pointer bg-current ${className}`}
        onClick={onClick}
        aria-hidden="true"
        style={{
          WebkitMask: `url(${localIconSrc}) center / contain no-repeat`,
          mask: `url(${localIconSrc}) center / contain no-repeat`,
          ...style,
        }}
        {...others}
      />
    );
  }

  return (
    <Icon
      icon={icon}
      className={`w-5 h-5 dark:text-dark_primary_label text-light_primary_label cursor-pointer ${className}`}
      onClick={onClick}
      style={style}
      {...others}
    />
  );
};

export default Iconify;
